
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change, submit as submitForm, formValueSelector, reduxForm } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';

import cx from 'classnames';

import CurrencyConverter from '../../CurrencyConverter';
import ListingDiscounts from '../../ListingDiscounts/ListingDiscounts';
import ListingPhotos from '../ListingPhotos';
import WishListIcon from '../../WishListIcon';

// Locale
import messages from '../../../locale/jsonMessages';

import { formatURL } from '../../../helpers/formatURL';

//Image
import streeingIcon from '/public/SiteIcons/steeringIcon.svg';
import startIcon from '/public/SiteIcons/star.svg';
import arrowIcon from '/public/SiteIcons/rentNowArrow.svg';

import { InstantBookSvgIcon } from '../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import cs from '../../commonStyle.css'
import s from './ListingItem.css';

class ListingItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  static propTypes = {
    formatMessage: PropTypes.func,
    id: PropTypes.number,
    basePrice: PropTypes.number,
    currency: PropTypes.string,
    title: PropTypes.string,
    beds: PropTypes.number,
    personCapacity: PropTypes.number,
    carType: PropTypes.string,
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    bookingType: PropTypes.string.isRequired,
    reviewsCount: PropTypes.number,
    reviewsStarRating: PropTypes.number,
    wishListStatus: PropTypes.bool,
    isListOwner: PropTypes.bool
  };

  handleMouseOver(value) {
    const { change } = this.props;
    change('SearchForm', 'markerHighlight', { 'id': value, 'hover': 'true' });
  }

  handleMouseOut(value) {
    const { change } = this.props;
    change('SearchForm', 'markerHighlight', {});
  }

  render() {
    const { formatMessage } = this.props.intl;
    const {
      id,
      basePrice,
      currency,
      title,
      beds,
      personCapacity,
      carType,
      coverPhoto,
      listPhotos,
      bookingType,
      reviewsCount,
      reviewsStarRating,
      wishListStatus,
      isListOwner,
      transmission,
      personalized
    } = this.props;

    let bedsLabel, guestsLabel, heartIcon, transmissionLabel;
    bedsLabel = 'Trip';
    guestsLabel = 'guest';
    heartIcon = 'heartIcon';
    if (beds > 1) {
      bedsLabel = 'Trips';
    }

    if (personCapacity > 1) {
      guestsLabel = 'guests';
    }
    let starRatingValue = 0;
    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Math.round(reviewsStarRating / reviewsCount)
    }
    let activeItem = 0, photoTemp, photosList = listPhotos.slice();
    if (listPhotos?.length > 1) {
      listPhotos.map((x, y) => { if (x.id === coverPhoto) activeItem = y });
      if (activeItem > 0) {
        photoTemp = photosList[0];
        photosList[0] = photosList[activeItem];
        photosList[activeItem] = photoTemp;
      }
    }

    transmission == '1' ? transmissionLabel = formatMessage(messages.automatic) : transmissionLabel = formatMessage(messages.manual);
    let personalizeURL = '', startDate, endDate, location;
    startDate = personalized?.startDate ? "?&startdate=" + personalized?.startDate : '';
    endDate = personalized?.endDate ? "&enddate=" + personalized?.endDate : '';
    personalizeURL = startDate + endDate;

    if (personalized?.location && personalized?.startDate && personalized?.endDate) {
      startDate = personalized?.startDate ? "&startdate=" + personalized?.startDate : '';
      location = personalized?.location ? "?&address=" + personalized?.location : '';
      personalizeURL = location + startDate + endDate;
    } else if (personalized?.location) {
      location = personalized?.location ? "?&address=" + personalized?.location : '';
      personalizeURL = location
    }

    return (
      <div className={cx(s.listItemContainer)} onMouseOver={() => this.handleMouseOver(id)} onMouseOut={() => this.handleMouseOut(id)}>
        {
          !isListOwner && <WishListIcon listId={id} key={id} isChecked={wishListStatus} heartIcon={heartIcon} />
        }

        <ListingDiscounts variant="badge" weeklyDiscount={this.props.weeklyDiscount} monthlyDiscount={this.props.monthlyDiscount}
          startDate={personalized?.startDate} endDate={personalized?.endDate} />
        <ListingPhotos
          id={id}
          coverPhoto={coverPhoto}
          listPhotos={photosList}
          formatURL={formatURL}
          title={title}
          personalizeURL={personalizeURL}
        />


        <div className={s.listInfo}>
          <a className={s.listInfoLink} href={"/cars/" + formatURL(title) + '-' + id + personalizeURL} target={"_blank"}>
            <div className={cx(cs.listingCardCarTypeAndTransmissionLabelFlexContainer, cs.spaceTop1)}>
              <div className={cs.textFlow}>
                <img src={streeingIcon} className={cs.carTypeIcon} />{' '}
                <span>{carType}</span>
              </div>
              <div className={cx(cs.textFlow, cs.transmissionLabelText, 'transmissionLabelTextRtl')}>{transmissionLabel}</div>
            </div>
            <div className={cx(s.priceCss, cs.commonSubTitleText, cs.fontWeightBold)}>
              {
                bookingType === "instant" && <span><InstantBookSvgIcon className={s.instantIcon} /></span>
              }

              <div>{
                <CurrencyConverter
                  amount={basePrice}
                  from={currency}
                />
              }
                {' '}<span className={cx(cs.fontWeightNormal, cs.commonSmallText)}><FormattedMessage {...messages.perNight} /></span>
              </div>
            </div>
            <div className={cx(s.textEllipsis, s.listingTitle, 'directionLtr', 'textAlignRightRTL', cs.commonContentText)}>
              {title}

            </div>
            <div className={s.HRRight}>
              {starRatingValue > 0 && <div className={cx(s.reviewCss, 'reviewCssSliderRTL')}>
                <img src={startIcon} className={cx(s.reviewCssImg, 'reviewCssImgRTL')} /> {starRatingValue}
              </div>}
              <a className={s.btn} href={"/cars/" + formatURL(title) + '-' + id + personalizeURL} target={'_blank'}>
                <FormattedMessage {...messages.rentNowText} />
                <img src={arrowIcon} className={cx(s.arrowIconCss, 'viewArrowLeft')} />
              </a>
            </div>
            {/* <Col xs={12} sm={12} md={12}
                className={cx(s.textEllipsis, s.infoReview, s.infoSpaceTop1)}
              >
                <div className={cx(s.reviewStar, 'small-star-rating')}>
                  <StarRating
                    value={starRatingValue}
                    name={'review'}
                    className={s.displayInline}
                    starColor={COMMON_TEXT_COLOR}
                    emptyStarColor={'#cccccc'}
                  />
                  <span className={s.textInline}>&nbsp; {reviewsCount + ' '}{reviewsCount > 1 ? formatMessage(messages.reviews) : formatMessage(messages.review)}
                  </span>
                </div>

              </Col> */}

          </a>
        </div>

      </div>
    );
  }
}

const mapState = (state) => ({
  personalized: state?.personalized,
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(ListingItem)));
